import { useMutation, useQueryClient } from '@tanstack/react-query';
import { connectService } from 'v2/services/connect';

export const useUpdateConnectAction = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ connectId, action }: { connectId: number; action: any }) =>
      connectService.updateAction(connectId, action),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['connect', 'actions'] });
    }
  });

  return { updateConnectAction: mutation.mutateAsync, isUpdating: mutation.isPending };
};
